import React from 'react';

import { FormControlLabel, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MailPreference } from '@/models/MailPreferenceModel';
import { Queries } from '@/queries/Queries';

type MailPreferenceItemType = {
  mail: MailPreference;
  className?: string;
};

export const MailPreferenceItem: React.FC<MailPreferenceItemType> = ({
  mail,
  className,
}) => {
  const { t } = useTranslation();

  const updatePreference = Queries.mailPreference.useUpdatePreference();
  const clickHandler = () => {
    updatePreference.mutate({ id: mail.id, enabled: !mail.enabled });
  };

  const label = t(`pages.account.preferences.${mail.label}`);

  return (
    <div
      id={`mail-preference-${mail.label}-toggle`}
      data-action="mail-preference-toggle"
      data-label={mail.label}
      className={className}
    >
      <FormControlLabel
        control={
          <Switch
            onChange={clickHandler}
            checked={mail.enabled}
            color="success"
          />
        }
        label={<Typography variant="body">{label}</Typography>}
      />
    </div>
  );
};
